<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        Surat Peringatan
      </div>

      <b-row>
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No.Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  disabled
                  v-model="model.no_kontrak"
                  @keyup.13.native="lkuPinjamanShow=true"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tgl. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tgl_kontrak" type="date" disabled style="float: right;"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Penggunaan</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.uraian" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.model_pinjaman=='PAB'">
                <label style="width:150px;">Pokok Pinjaman</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label style="width:150px;">Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.model_pinjaman=='PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:150px;">Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bunga_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.model_pinjaman=='PAB'">
              <b-input-group-prepend>
                <label style="width:150px;">Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label style="width:150px;">Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.bungaod_tarifthn"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-card no-body border-variant="info" header="History SP" align="center" v-show="!this.$route.params.pinjamankey">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          hover
          style="font-size: smaller"
          :items="dataSPHistory"
          :fields="tblFields"
          show-empty
        >
        <template v-slot:cell(tglsurat)="data">{{
          data.item.tglsurat | moment("DD/MM/YY")
        }}</template>
        <template v-slot:cell(expiredate)="data">{{
          data.item.expiredate | moment("DD/MM/YY")
        }}</template>
        <template v-slot:cell(tglperhitungan)="data">{{
          data.item.tglperhitungan | moment("DD/MM/YY")
        }}</template>
        <template v-slot:cell(tunggakanpokok)="data">{{
          data.item.tunggakanpokok | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(tunggakanbunga)="data">{{
          data.item.tunggakanbunga | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(tunggakandenda)="data">{{
          data.item.tunggakandenda | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(tunggakantotal)="data">{{
          data.item.tunggakantotal | numFormat("0,0.00")
        }}</template>
        </b-table>
    </b-card>
      <hr v-show="!this.$route.params.suratkey" />
      <b-card border-variant="info" header="Detail Info" align="center">
        <b-card-text>
          <b-form @submit="event.preventDefault()">
            <b-row>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tanggal Surat</label>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="model.tglsurat"
                    disabled
                  ></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Nomor Surat</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.nosurat" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Jenis Surat</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.namasurat" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Masa Berlaku</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.validPeriodVal" disabled></b-form-input>
                  <b-form-input v-model="model.validPeriodUOM" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Berlaku sampai</label>
                  </b-input-group-prepend>
                  <b-form-input disabled class="form-control-plaintext" :value="model.expiredate | moment('DD MMM YYYY')"></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Status</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.statussp" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Keterangan</label>
                  </b-input-group-prepend>
                  <b-form-textarea
                    id="textarea"
                    v-model="model.note"
                    placeholder="Tambahkan keterangan.."
                    rows="3"
                    max-rows="6"
                    disabled
                  ></b-form-textarea>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Confirm Phone</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.confirmphone" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tembusan</label>
                  </b-input-group-prepend>
                  <b-form-textarea
                    id="textarea"
                    v-model="model.tembusan"
                    placeholder="Tambahkan tembusan.."
                    rows="3"
                    max-rows="6"
                    disabled
                  ></b-form-textarea>
                </b-input-group>
              </b-col>
              <b-col lg="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tgl Perhitungan</label>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="model.tglperhitungan"
                    disabled
                  ></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tunggakan Pokok</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number
                    disabled
                    v-model="model.tunggakanpokok"
                    :precision="2"
                    class="text-right"
                  ></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Tunggakan Bunga</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number
                    disabled
                    v-model="model.tunggakanbunga"
                    :precision="2"
                    class="text-right"
                  ></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Denda Keterlambatan</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number
                    disabled
                    v-model="model.tunggakandenda"
                    :precision="2"
                    class="text-right"
                  ></my-number>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:200px;" class="text-right">Total Tunggakan</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text ml-2" style="width:70px;">IDR</span>
                  </b-input-group-prepend>
                  <my-number
                    disabled
                    v-model="model.tunggakantotal"
                    :precision="2"
                    class="text-right"
                  ></my-number>
                </b-input-group>
              </b-col>
            </b-row>
            <hr />
            <b-row>
              <b-col lg="6">
                <h6 class="text-center">Penandatangan</h6>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:100px;">Nama</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.ttd1nama" disabled></b-form-input>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label style="width:100px;">Jabatan</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.ttd1jabatan" disabled></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-text>
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import lkuPinjaman from "./lkuPinjaman";
import speringatan from "../../apis/suratperingatan";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { myNumber, lkuPinjaman,Loading },
  mixins: [validationMixin],
  validations: {
    model: {},
  },
  data() {
    return {
      isLoading:false,
      model: {
        no_kontrak: "",
        pinjamankey: "",
        model_pinjaman: "",
        principal: "",
        matauang: "",
        interest: "",
        installment_amount: "",
        interestod: "",
        tglsurat: moment().format('YYYY-MM-DD'),
        expiredate: "",
        lamahari: "",
        tembusan: `- Bagian Hukum/Legal\n- Bagian Penagihan dan Lelang\n- Koordinator Area dan Tim Penanganan`,
        statussp: null,
        nosurat: "",
        jenissuratkey: null,
        tunggakanpokok: 0,
        tunggakanbunga: 0,
        tunggakandenda: 0,
        tunggakantotal: 0,
        ttd1nama: "Purnomosidi",
        ttd1jabatan: "Kepala Operasional",
        confirmphone: "08111279218",
        tglperhitungan: moment().format("YYYY-MM-DD"),
        validPeriodVal:1,
        validPeriodUOM:'weeks'
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglsurat",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        jenissuratkey: null,
      },
      optionsStts: [
        { value: null, text: "Pilih status" },
        { value: "lancar", text: "Lancar" },
        { value: "gugur", text: "Gugur" },
      ],
      optJenisSurat: [
        {
          value: null,
          text: "-- Please select an option --",
          disabled: true,
        },
      ],
      optionsValidPeriodVal: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
      ],
      optionsValidPeriodUOM: [
        { value: 'weeks', text: "MINGGU" },
        { value: 'months', text: "BULAN" }
      ],
      lkuPinjamanShow: false,
    };
  },    
  created: async function () {
    if (this.$route.params.suratkey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        const res = await speringatan.detail(this.$route.params.suratkey);
        for (const key in res) {
          if (res.hasOwnProperty(key)) {
            this.model[key] = res[key];
          }
        }
        this.model.tglsurat = moment(this.model.tglsurat).format("YYYY-MM-DD");
        this.model.expiredate = moment(this.model.expiredate).format(
          "YYYY-MM-DD"
        );
        this.model.tgl_kontrak = moment(this.model.tgl_kontrak).format(
          "YYYY-MM-DD"
        );

        this.model.tglperhitungan = this.model.tglperhitungan
          ? moment(this.model.tglperhitungan).format("YYYY-MM-DD")
          : "";

        this.model.validPeriodVal = moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks') > 4 ? moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks') / 4 : moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks');
        this.model.validPeriodUOM = moment(this.model.expiredate).diff(moment(this.model.tglsurat), 'weeks') > 4 ? 'months' : 'weeks';

        this.$refs.table.refresh();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }else{
      this.model.nosurat=`/MF/DIR/${this.integer_to_roman(parseInt(moment().format('M')))}/${moment().format('YYYY')}`
    }
    let workflowSP = await speringatan.getworkflowSP();
    this.model.ttd1nama = this.model.ttd1nama ? this.model.ttd1nama : workflowSP[0].full_name;
    this.model.ttd1jabatan = this.model.ttd1jabatan ? this.model.ttd1jabatan : workflowSP[0].jabatan;
    this.model.tembusan = this.model.tembusan ? this.model.tembusan : `Bagian Hukum/Legal\nBagian Penagihan dan Lelang Kantor Pusat\nKoordinator Area dan Tim Penanganan`;
    this.model.confirmphone = this.model.confirmphone ? this.model.confirmphone : `08111279218`;

    const spDtset = {
      tablename: "surat-peringatan",
      page: 1,
      limit: 100,
      total: 0,
      sortBy: "nourut",
      sortDesc: "false",
    };
    const srtperingatan = await crud.list(spDtset);
    srtperingatan.map((item) => {
      this.optJenisSurat.push({
        value: item.jenissuratkey,
        text: item.namasurat,
      });
    });
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "tglsurat",
          label: "Tgl. Surat",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. Surat",
          thStyle: "width:90px",
          thClass: "text-center",
          sortable: true,
        },
        
        {
          key: "namasurat",
          label: "Jenis Surat",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "expiredate",
          label: "Berlaku Sampai",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "statussp",
          label: "Status",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tglperhitungan",
          label: "Tgl. Perhitungan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttd1nama",
          label: "Nama Penandatangan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttd1jabatan",
          label: "Jabatan Penandatangan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "DIterbitkan Oleh",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch: {
    "model.tglsurat"(val){
      const expiredate = moment(val).add(this.model.validPeriodVal,this.model.validPeriodUOM);
      this.model.expiredate = moment(expiredate).format("YYYY-MM-DD");
    },
    "model.validPeriodVal"(val){
      const expiredate = moment(this.model.tglsurat).add(val,this.model.validPeriodUOM);
      this.model.expiredate = moment(expiredate).format("YYYY-MM-DD");
    },
    "model.validPeriodUOM"(val){
      const expiredate = moment(this.model.tglsurat).add(this.model.validPeriodVal,val);
      this.model.expiredate = moment(expiredate).format("YYYY-MM-DD");
    },
  },
  methods: {
    integer_to_roman(num) {
      if (typeof num !== 'number') 
      return false; 

      var digits = String(+num).split(""),
      key = ["","C","CC","CCC","CD","D","DC","DCC","DCCC","CM",
      "","X","XX","XXX","XL","L","LX","LXX","LXXX","XC",
      "","I","II","III","IV","V","VI","VII","VIII","IX"],
      roman_num = "",
      i = 3;
      while (i--)
      roman_num = (key[+digits.pop() + (i * 10)] || "") + roman_num;
      return Array(+digits.join("") + 1).join("M") + roman_num;
    },

    async onSelectLkuPinjaman(_selected) {
      try {
        console.log('')
        this.model.pinjamankey = _selected.pinjamankey;
        this.model.nasabahkey = _selected.nasabahkey;
        this.model.no_kontrak = _selected.no_kontrak;
        this.model.tgl_kontrak = _selected.tgl_kontrak;
        this.model.CustName = _selected.CustName;
        this.model.uraian = _selected.uraian;
        this.model.model_pinjaman = _selected.model_pinjaman;
        this.model.principal = _selected.principal;
        this.model.plafon = _selected.plafon;
        this.model.bunga_tarifthn = _selected.bunga_tarifthn;
        this.model.installment_amount = _selected.installment_amount;
        this.model.bungaod_tarifthn = _selected.bungaod_tarifthn;
        this.model.bankcode = _selected.bankcode;
        this.model.vanumber = _selected.vanumber;
        this.model.accowner = _selected.accowner;
        this.model.note = `${_selected.namabank} \n No Rekening Virtual Account: ${_selected.vanumber} \n Atas Nama: ${_selected.accowner}` ;
        this.model.tgl_kontrak = _selected.tgl_kontrak
          ? moment(_selected.tgl_kontrak).format("YYYY-MM-DD")
          : "";
        this.lkuPinjamanShow = false;
        this.$refs.table.refresh();
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async calculate() {
      try {
        this.isLoading = true;
        const res = await speringatan.calcPelunasan(this.model);
        const data = res[0]
        if (data[0]) {
          this.model.tunggakanpokok = data[0].sum_angsrn_principal;
          this.model.tunggakanbunga = data[0].sum_angsrn_interest;
          this.model.tunggakandenda = data[0].os_denda;
          this.model.count_angsuran = data[0].count_angsuran;
          this.model.angsuran_dari = data[0].angsuran_dari;
          this.model.angsuran_ke = data[0].angsuran_ke;
          this.model.tunggakantotal =
            this.model.tunggakanpokok +
            this.model.tunggakanbunga +
            this.model.tunggakandenda;

          if (this.model.model_pinjaman == "PAB") {
            this.model.tunggakanpokok = data[0].sum_angsrn_principal;
            this.model.tunggakanbunga = data[0].sum_angsrn_interest;
            this.model.tunggakandenda = data[0].os_denda;
            this.model.count_angsuran = data[0].count_angsuran;
            this.model.angsuran_dari = data[0].angsuran_dari;
            this.model.angsuran_ke = data[0].angsuran_ke;
            this.model.tunggakantotal =
              this.model.tunggakanpokok +
              this.model.tunggakanbunga +
              this.model.tunggakandenda;
          }

        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    dataSPHistory: async function (ctx) {
      if (this.model.pinjamankey) {
        try {
          const list = await speringatan.listSPHistory(this.model);
          let suratkeyArr = [];
          if(list){
            list.map((item, idx) => {
              suratkeyArr.push(item.suratkey);
            });
          }
          this.model.spreference = suratkeyArr.toString() || "";
          return list;
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }else{
        return [];
      }
    },

    async save() {
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        } else {
          await speringatan.save(this.model);
          toastr.success("Data berhasil disimpan");
          router.push({ name: "loan.history-sp" });
        }
      } catch (error) {
        console.log("error : ", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "loan.history-sp" });
    },
  },
};
</script>
